import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";
import Photoswipe from "./photoswipe.esm.min.js";

document.addEventListener('DOMContentLoaded', function() {
  if (window.navyProductMediaData && window.navyProductMediaData.length > 0) {
    // Rest of code remains the same
    window.onload = function() {
      function preloadImage(url) {
        const img = new Image();
        img.src = url;
      }

      function preloadSrcset(srcset) {
        const sources = srcset.split(', ');
        sources.forEach(source => {
          const src = source.split(' ')[0];
          preloadImage(src);
        });
      }

      window.navyProductMediaData.forEach(media => {
        if (media.mediaType !== 'image') return;

        preloadImage(media.src);
        if (media.srcset) {
          preloadSrcset(media.srcset);
        }
      });
    }

    // const zoomSvgString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-zoom"></use><path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"></path><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"></path><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"></path></svg>';
    // const closeSvgString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-close"></use><path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"></path></svg>';
    // const zoomSvgString = '<svg aria-hidden="true" class="pswp__icn navy-test-class" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-zoom"></use><path stroke-width="1.5" d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"></path><path fill="currentColor" stroke-width="1.5" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"></path><path fill="currentColor" stroke-width="1.5" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"></path></svg>';
    
    // const closeSvgString = '<svg aria-hidden="true" class="pswp__icn navy-test-class" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-close"></use><path stroke-width="1.5" d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"></path></svg>';
    const zoomSvgString = '';
    
    const closeSvgString = '';
    
    const options = {
      dataSource: window.navyProductMediaData,
      showHideAnimationType: 'none', 
      pswpModule: () => Photoswipe,
      counter: false,
      maxZoomLevel: 3,
      zoomSvg: zoomSvgString,
      closeSvg: closeSvgString,
      mainClass: 'navy-pswp',
    };

    const lightbox = new PhotoSwipeLightbox(options);

    function preparePopupVideo(video) {
      video.muted = true;
      video.loop = true;
      video.controls = false;
      video.setAttribute('muted', 'muted');
      video.setAttribute('loop', 'loop');
      video.removeAttribute('controls');
      video.setAttribute('playsinline', 'playsinline');
      video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    }

    lightbox.on('contentActivate', function(event) {
      const video = event.content.element?.querySelector?.('video.navy-pswp-video');
      let playPromise;

      if (!video) return;

      preparePopupVideo(video);

      try {
        playPromise = video.play();
      } catch (error) {
        playPromise = null;
      }

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    });

    lightbox.on('contentDeactivate', function(event) {
      const video = event.content.element?.querySelector?.('video.navy-pswp-video');

      if (!video) return;

      try {
        video.pause();
      } catch (error) {}
    });

    lightbox.on('close', function() {
      document.querySelectorAll('.navy-pswp-video').forEach(function(video) {
        try {
          video.pause();
        } catch (error) {}
      });
    });

    lightbox.init();

    function getProductMediaIndex(toggle) {
      const mediaContainer = toggle.querySelector('[data-media-id]');
      const mediaId = mediaContainer ? mediaContainer.getAttribute('data-media-id') : '';
      const mediaPosition = toggle.getAttribute('data-index');

      return window.navyProductMediaData.findIndex(media => {
        const itemMediaId = media.mediaId != null ? String(media.mediaId) : '';
        const itemMediaPosition = media.mediaPosition != null ? String(media.mediaPosition) : '';

        return (
          mediaId && (mediaId === itemMediaId || mediaId.endsWith(`-${itemMediaId}`))
        ) || (
          mediaPosition && mediaPosition === itemMediaPosition
        );
      });
    }

    document.addEventListener('click', function(event) {
      const mediaToggle = event.target.closest('.productView-image');

      if (!mediaToggle) return;
      if (mediaToggle.querySelector('iframe, model-viewer, product-model')) {
        return;
      }

      const mediaIndex = getProductMediaIndex(mediaToggle);

      if (mediaIndex < 0) return;

      event.preventDefault();
      lightbox.loadAndOpen(mediaIndex);
    });
  }
});
